const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_cVISqCgGq",
    "aws_user_pools_web_client_id": "3phf77ia3en51fmt4ks1d5o994",
    "oauth": {},
    "federationTarget": "COGNITO_USER_POOLS"
};

export default awsmobile;